export const chartGlobalLabelDefaults = {
  style: {
    fontFamily: '"Muli", sans-serif',
    fontStyle: 'normal 1em',
    circleFillColor: '#f3f7ff',
    textfillColor: '#292c32',
    borderColor: '#c6cbd2',
    darkBorderColor: '#4b4e54',
    dashlineColor: '#a9adb4',
    darkDashlineColor: '#6a6e75',
    textBaseline: 'middle',
    textAlign: 'center',
    smallText: 'normal 0.8em'
  },
  text: {
    nodata: 'No data to display'
  }
}



// WEBPACK FOOTER //
// ./src/constants/chart-global-styles.constants.js